import {
  HttpClient,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable, forwardRef, Inject, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from '../../../node_modules/rxjs/operators';
import { Log } from 'ng2-logger';
import { Platform, Events } from 'ionic-angular';

declare var window;

/*
*

*
*/
@Injectable()
export class HttpErrorInterceptorProvider implements HttpInterceptor {
  interval: any;
  constructor(public platform: Platform, public events: Events) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError(error => this.errorHandler(error, request)));
  }

  private errorHandler(
    response: HttpEvent<any>,
    request: HttpRequest<any>
  ): Observable<HttpEvent<any>> {
    if (response['status'] === 401 && request.url.includes('soa-1/services')) {
      let log = Log.create('Http interceptor error handler ');
      log.er('Ovo je error u Htttp interceptoru');
      localStorage.clear();
      this.events.publish('user:logout');
      // if(this.platform.is('ios') || this.platform.is('android')) {
      //   //window.location.href = window.location.pathname + '#/welcome';
      // } else {
        //window.location.href = window.origin + '/#/welcome';
      // }
    }
    throw response;
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-error-interceptor/http-error-interceptor.ts